export const Logo = ({ className }: { className?: string }) => (
  <div className={className}>
    <h1 className="font-display text-2xl font-bold tracking-tight text-navy-700">
      LICITA<span className="text-gold-500">.</span>MIND
    </h1>
    <p className="text-xs text-navy-500 mt-0.5">pesquisa de preços · Lei 14.133/21</p>
  </div>
);
